const jobs = {
  permissionSource: 'api::job.job',
  creationTitle: 'Create Job',
  creationEndPoint: '/jobs',
  detailTitle: 'Job: :title',
  detailEndPoint: '/jobs/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Project Code',
          required: true,
        },
        {
          label: 'Desc',
          value: 'desc',
          tag: 'input',
          type: 'text',
          placeholder: 'Desc',
        },
      ],
    },

    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Job Progress',
          value: 'job_progress',
          tag: 'input',
          type: 'number',
          placeholder: 'Job Progress',
        },
        {
          label: 'Job Category',
          value: 'job_category',
          tag: 'single-select',
          dataSourceUrl: '/job-categories',
          dataLabel: 'name',
          required: false,
        },
      ],
    },

    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Title',
          value: 'title',
          tag: 'input',
          type: 'text',
          placeholder: 'Title',
          required: true,
        },
        {
          label: 'Salary',
          value: 'salary',
          tag: 'input',
          type: 'number',
          placeholder: 'Salary',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Location',
          value: 'location',
          tag: 'input',
          type: 'text',
          placeholder: 'Location',
          required: true,
        },
        {
          label: 'EmploymentType',
          value: 'employment_type',
          tag: 'single-enum-select',
          dataSourceUrl: '/content-type-builder/content-types/api::job.job',
          dataLabel: 'employment_type',
          required: false,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Appoint Staff',
          value: 'appoint_staff',
          tag: 'single-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
          required: false,
        },
        {
          label: 'Sales Quotation',
          value: 'sales_quotation',
          tag: 'single-select',
          dataSourceUrl: '/sales-quotations',
          dataLabel: 'code',
          required: false,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Contract',
          value: 'contract',
          tag: 'single-select',
          dataSourceUrl: '/contracts',
          dataLabel: 'code',
          required: false,
        },
        {
          label: 'External Document',
          value: 'external_documents',
          tag: 'multi-select',
          dataSourceUrl: '/external-documents',
          dataLabel: 'name',
          required: false,
        },
      ],
    },
    {
      label: 'Other Documents',
      value: 'other_documents',
      tag: 'multi-media',
      acceptFile: '*',
    },
    {
      label: 'Requirements',
      value: 'requirements',
      tag: 'richTextarea',
    },
    {
      label: 'Responsibilities',
      value: 'responsibilities',
      tag: 'richTextarea',
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default jobs
